import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../_services/session-storage.service';
import { NavigationService } from 'src/app/_services/navigation-service.service';

@Component({
  selector: 'app-register-header',
  templateUrl: './register-header.component.html',
  styleUrls: ['./register-header.component.scss'],
  standalone: false,
})
export class RegisterHeaderComponent {
  @Input() step: number = 0;
  @Input() selectedRole: string = '';
  @Output() backClicked = new EventEmitter<number>();

  constructor(
    private router: Router,
    private sessionStorageService: SessionStorageService,
    private navigationService: NavigationService
  ) { }

  onBackClick() {
    if (this.step === 0) {
      // this.router.navigate(['/login']);
      this.navigationService.goToPreviousPage();
    }
    else {
      this.backClicked.emit(this.step);
    }
    // Clear session data when user abandons registration process
    this.sessionStorageService.clearRegisterState();

  }
} 